import { render, staticRenderFns } from "./SafeForWork1.vue?vue&type=template&id=731e7667&scoped=true&"
import script from "./SafeForWork1.vue?vue&type=script&lang=js&"
export * from "./SafeForWork1.vue?vue&type=script&lang=js&"
import style0 from "./SafeForWork1.vue?vue&type=style&index=0&id=731e7667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e7667",
  null
  
)

export default component.exports